import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { PaymentHistoryState } from '../state/payment-history.state';
import { initialPaymentHistoryState } from '../state/payment-history.state';
import { loadPaymentHistoryError, loadPaymentHistoryList, loadPaymentHistorySuccess } from '../action/payment-history.action';

const paymentHistoryReducer = createReducer(
  initialPaymentHistoryState,

  on(loadPaymentHistoryList, (state: PaymentHistoryState) => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
    })),

  on(loadPaymentHistorySuccess, (state: PaymentHistoryState, { paymentHistory }) => ({
      ...state,
      paymentHistory,
      loaded: true,
      loading: false,
    })),

  on(loadPaymentHistoryError, (state: PaymentHistoryState, { error }) => ({
      ...state,
      error,
      loading: false,
      loaded: true,
    })),
);

export function PaymentHistoryReducer(state: PaymentHistoryState | undefined, action: Action): PaymentHistoryState {
  return paymentHistoryReducer(state, action);
}
